var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"search-form"},[(_vm.allow('A'))?_c('b-button',{directives:[{name:"show",rawName:"v-show",value:(!_vm.disabled),expression:"!disabled"}],attrs:{"size":"sm","variant":"outline-success"},on:{"click":function($event){return _vm.$emit('openEditFormDialog', {
        type: 'add',
      })}}},[_c('b-icon-plus'),_vm._v(_vm._s(_vm.$l('INDEX.btn_add') || '新增')+" ")],1):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }